import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getOfferHistory, setPage } from '../../../../store/offerHistory/actions';
import { selectPageNumber } from '../../../../store/offerHistory/selectors';
import { THandleShowMoreClick } from '../../components/types';
import { selectOfferId } from '../../../../selectors/offerData/offer';
import { trackShowMoreClick } from '../analytics';

/**
 * Хэндлер клика по кнопке "Загрузить еще"
 * */
export const useHandleShowMoreClick = (): THandleShowMoreClick => {
  const dispatch = useDispatch();
  const pageNumber = useSelector(selectPageNumber);
  const offerId = useSelector(selectOfferId);

  return React.useCallback(() => {
    dispatch(setPage(pageNumber + 1));
    dispatch(getOfferHistory(true));

    trackShowMoreClick(offerId);
  }, [dispatch, pageNumber, offerId]);
};
